<template lang="pug">
	.networks(v-bar)
		.networks-content
			.dropdown-item(@click="setNetwork('js-minified')")
				.item-title Minified Javascript
				.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/networks/javascript-minified.jpg)'}")
				.item-description.text-muted Output minified Javascript as creative.min.js
			.dropdown-item(@click="setNetwork('js-all')")
				.item-title All Javascript
				.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/networks/javascript-all.jpg)'}")
				.item-description.text-muted Output regular and minified Javascript as creative.js and creative.min.js
			.dropdown-item(@click="setNetwork('js-normal')")
				.item-title Normal Javascript
				.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/networks/javascript-normal.jpg)'}")
				.item-description.text-muted Output regular non-minified Javascript as creative.js
			//.dropdown-item(v-if="Template.SelectedTemplate && Template.SelectedTemplate.id === 3 && scope === 'download'" @click="setNetwork('video')")
			.dropdown-item(v-if="Template.SelectedTemplate && Template.SelectedTemplate.id === 3 && !isServer" @click="setNetwork('video')")
				.item-title Video
				.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/networks/mp4.png)'}")
				.item-description.text-muted Output expanded state as mp4 video
			//-.dropdown-item(@click="setNetwork('websites-only')")
				.item-title Websites only
				.item-description.text-muted Update websites data for release
			//.dropdown-item.disabled(@click="setNetwork('google')")
				.item-title Google Ads
				.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/networks/google.png)'}")
				.item-description.text-muted Desktop rich media format for Google (javascript file).
			//.dropdown-item.disabled(@click="setNetwork('web')")
				.item-title Web
				.item-icon(v-bind:style="{backgroundImage: 'url(/img/icons/networks/web.png)', width: '55px'}")
				.item-description.text-muted Web fullscreen preview with example website overlay.
			//-
				.dropdown-item(@click="setNetwork('sources')")
					.item-title Sources
					.item-icon(v-bind:style="{background: 'url(/Images/Icons/Networks/sources.png) right 6px / auto 36% no-repeat'}")
					.item-description.text-muted Web version with uncompressed source files
</template>

<script>

	import Screen from './../../mixins/screen';
	import {Template} from "@/services/Template";

	export default {
		name: "NetworkList",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Template Changed"]
		},
		props: ['callback', 'scope', 'isServer'],
		data() {

			this.Template = Template;

			return {
				showed: true
			};

		},
		methods: {
			setNetwork(name) {

				this.callback(name);

			}
		}
	}
</script>

<style lang="sass">

	.networks
		height: 350px
		overflow-x: hidden
		overflow-y: auto

		.dropdown-item
			white-space: normal
			padding: 0px 20px 10px 20px
			width: 250px

			.item-title
				margin-bottom: 5px
				padding-top: 5px

			.item-description
				white-space: normal
				line-height: 12px
				font-size: 0.6rem
				width: 66%

			.item-icon
				position: absolute
				top: 5px
				right: 10px
				width: calc(37% - 10px)
				height: 44px
				opacity: 1
				background-size: contain
				background-repeat: no-repeat
				background-position: right center
				max-height: 55px

		.dropdown-item.disabled
			opacity: 0.3
			cursor: default

	.networks::-webkit-scrollbar
		width: 10px
		margin-left: -10px
		-webkit-appearance: none
		appearance: none

	.networks::-webkit-scrollbar-track
		background-color: rgba(255,255,255,0.3)
		border-right: 1px solid #f2f2f2
		border-left: 1px solid #f2f2f2

	.networks::-webkit-scrollbar-thumb
		height: 50px
		background-color: rgba(255,255,255,0.2)
		background-clip: content-box
		border-color: transparent
		border-style: solid
		border-width: 1px 2px

</style>

